module.exports = __webpack_public_path__ + "img/61428e8479251302629ebbe4a635b5c0.png";